import {
  CalendarBlankIcon,
  ClockClockwiseIcon,
  ClockIcon,
  CoinsIcon,
  GiftIcon,
  LightningSlashIcon,
  MoneyIcon,
  ProhibitIcon,
} from '@phosphor-icons/react'

import { GiftCardIcon, OriginalPaymentMethodIcon } from '@reveni-io/reveni-ui'

export const dateStates = {
  pending: 'pending',
  active: 'active',
  expired: 'expired',
}

export const actionTypes = {
  block_order_options: {
    icon: ProhibitIcon,
    labelKey: 'Bloquear pedido',
  },
  block_item_options: {
    icon: ProhibitIcon,
    labelKey: 'Bloquear producto',
  },
  disable_instant: {
    icon: LightningSlashIcon,
    labelKey: 'Desactivar instantáneo',
  },
  extend_window: {
    icon: CalendarBlankIcon,
    labelKey: 'Ampliar plazo',
  },
  put_on_hold: {
    icon: ClockIcon,
    labelKey: 'En espera',
  },
  put_refund_on_hold: {
    icon: MoneyIcon,
    labelKey: 'Retener reembolso',
  },
  apply_bonus: {
    icon: GiftIcon,
    labelKey: 'Bonificación',
  },
  apply_fee_item: {
    icon: CoinsIcon,
    labelKey: 'Cargo extra',
  },
  apply_fee_request: {
    icon: CoinsIcon,
    labelKey: 'Cargo extra',
  },
  force_refund_trigger: {
    icon: ClockClockwiseIcon,
    labelKey: 'Forzar trigger',
  },
  force_exchange_order_trigger: {
    icon: ClockClockwiseIcon,
    labelKey: 'Forzar trigger de exchange',
  },
  force_disable_refund_methods: {
    icon: GiftCardIcon,
    labelKey: 'Forzar método de reembolso',
  },
  disable_refund_methods: {
    icon: OriginalPaymentMethodIcon,
    iconType: 'slashed',
    labelKey: 'Desactivar método de reembolso',
  },
}
